import React from "react";
import { useStyles } from "./ContactDetail.styles";

interface Props {}

export const ContactDetail: React.FC<Props> = () => {
  const classes = useStyles();
  return <div className={classes.contactDetail_root}>Contact Detail</div>;
};
